import React, { useEffect, useState } from 'react'
import { useBreakpointValue } from '@chakra-ui/react'
import RegisterDesktop from './register.desktop'
import RegisterMobile from './register.mobile'
import { useSelector } from 'react-redux'
import { IRedux, IUser } from '@/app/[locale]/_store/types'
import { getSource } from '@/app/[locale]/_utils/platform'
import { toaster } from '@/components/ui/toaster'
import customerService from '@/app/[locale]/_service/customer.service'
import { useTranslations } from 'next-intl'

const initialData: IUser = {
  name: '',
  access_token: '',
  refresh_token: '',
  date_of_birth: '',
  phone: '',
  id: '',
}

const Auth = ({
  formData: initData,
  setActiveWindow,
  onSuccess,
}: {
  setActiveWindow: any
  formData: {
    phone: string
    name: string
  }
  onSuccess: (e: IUser) => void
}) => {
  const [loading, setLoading] = useState(false)
  const [errors, setErrors] = useState<{ name?: string }>({})
  const [formData, setFormData] = useState<IUser>(initialData)

  const settings = useSelector((state: IRedux) => state.settings)
  const { user } = useSelector((state: IRedux) => state.auth)
  const { fcm_token, platform_id, is_hall } = useSelector(
    (state: IRedux) => state.session
  )

  const t = useTranslations()
  const isDesktop = useBreakpointValue(
    { base: false, lg: true },
    { ssr: false }
  )

  const onRegister = async (e: any) => {
    e.preventDefault()
    setLoading(true)

    if (!formData.name) {
      setErrors({ name: t('this_field_required') })
      setLoading(false)
      return
    }

    const source = getSource({ is_hall })

    if ((source === 'ios' || source === 'android') && !settings.fcm_token) {
      toaster.create({
        title: 'FCM token is not found!',
        type: 'error',
      })
      setLoading(false)
      return
    }
    setErrors({})

    const data = {
      name: formData?.name,
      phone: initData?.phone?.length < 5 ? '' : initData?.phone,
      registration_source: source,
    }

    try {
      if (!settings?.data?.data?.is_otp) {
        const response = await customerService.registerWithoutOTP(
          {
            name: formData?.name,
            phone: data?.phone,
            ...(fcm_token ? { fcm_token } : {}),
          },
          platform_id
        )

        onSuccess(response?.data)
      } else {
        await customerService.register({
          ...data,
          fcm_token: settings.fcm_token || undefined,
        })

        setActiveWindow('register-confirmation')
      }
    } catch (error: any) {
      console.log(error)
      toaster.create({
        title: 'Error with ' + error?.status + 'status code',
        type: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  const onChange = (value: string, name: string) => {
    setFormData((prev) => ({ ...prev, [name]: value }))
    setErrors((prev) => ({ ...prev, [name]: '' }))
  }

  useEffect(() => {
    if (user) {
      setFormData((prev) => ({
        ...prev,
        ...user,
        name: !user.phone ? user?.name : '',
      }))
    }
  }, [user])

  if (isDesktop)
    return (
      <form onSubmit={onRegister}>
        <RegisterDesktop
          formData={formData}
          loading={loading}
          errors={errors}
          onChange={onChange}
        />
      </form>
    )

  return (
    <form onSubmit={onRegister}>
      <RegisterMobile
        formData={formData}
        loading={loading}
        errors={errors}
        onChange={onChange}
      />
    </form>
  )
}

export default Auth
